import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';

const styles = () => ({ breakpoints }: Theme) =>
  createStyles({
    button: {
      height: 43,
      minWidth: '140px !important',
      fontFamily: 'Roboto',
      padding: '6px !important',
      fontSize: '16px !important',
      fontWeight: 500,
      borderRadius: 4,
      [breakpoints.down('md')]: {
        height: 40,
      },

      '&:disabled': {
        filter: 'grayscale(100%)',
        opacity: 0.3,
      },
    },
  });

export default styles;
